import { useMutation } from '@tanstack/react-query'
import { processesApi } from '@/services/api/processes-api'

interface ChangeToBankTransferParams {
  processId: string
  email: string
  iban?: string
  swift?: string
  bban?: string
  bankAccountCountry?: string
}

export const useChangeToBankTransfer = () => {
  return useMutation({
    mutationFn: async (params: ChangeToBankTransferParams) => {
      const { data } = await processesApi.changeToBankTransfer(params)
      return data
    }
  })
}
